// This polyfill adds compatibility to `forEach` to all Browsers supporting ES5
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}
